if (!customElements.get('certificate-download')) {
  customElements.define(
    'certificate-download',
    class CertificateDownload extends HTMLElement {
      constructor() {
        super();
        this.link = this.querySelector('a');
        this.onClickHandler = this.onClick.bind(this);
      }

      connectedCallback() {
        if (!this.link) return;
        this.link.addEventListener('click', this.onClickHandler);
      }

      disconnectedCallback() {
        if (!this.link) return;
        this.link.removeEventListener('click', this.onClickHandler);
      }

      get url() {
        return this.link ? this.link.getAttribute('href') : null;
      }

      get filename() {
        return this.dataset.filename || 'certificate';
      }

      onClick(event) {
        const url = this.url;
        if (!url || this.classList.contains('loading')) return;

        event.preventDefault();
        this.setLoading(true);

        this.download(url)
          .catch(() => {
            window.open(url, '_blank', 'noopener');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        this.classList.toggle('loading', isLoading);
        if (this.link) {
          this.link.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        }
      }

      async download(url) {
        const response = await fetch(url, { mode: 'cors' });
        if (!response.ok) throw new Error(`Certificate download failed: ${response.status}`);

        const contentType = response.headers.get('content-type') || '';
        const disposition = response.headers.get('content-disposition') || '';
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = this.downloadName(url, contentType, disposition);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();

        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      }

      downloadName(url, contentType, disposition) {
        const fromHeader = this.filenameFromDisposition(disposition);
        if (fromHeader) return fromHeader;

        const fromUrl = decodeURIComponent((url.split('?')[0].split('/').pop() || '').replace(/\+/g, ' '));
        if (fromUrl && /\.[a-z0-9]{2,5}$/i.test(fromUrl)) return fromUrl;

        const base = this.filename || 'certificate';
        if (/\.[a-z0-9]{2,5}$/i.test(base)) return base;
        return base + this.getExtension(url, contentType);
      }

      filenameFromDisposition(header) {
        if (!header) return '';
        const encoded = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
        if (encoded) {
          try {
            return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ''));
          } catch (error) {
            return encoded[1].trim().replace(/^"|"$/g, '');
          }
        }
        const plain = header.match(/filename="?([^";]+)"?/i);
        return plain ? plain[1].trim() : '';
      }

      getExtension(url, contentType) {
        const match = url.split('?')[0].match(/\.([a-z0-9]+)$/i);
        if (match) return `.${match[1]}`;
        if (contentType.includes('pdf')) return '.pdf';
        if (contentType.startsWith('image/')) return `.${contentType.split('/')[1].split(';')[0]}`;
        return '';
      }
    }
  );
}
